import { render, staticRenderFns } from "./add-lead.vue?vue&type=template&id=36f9c9a0&scoped=true"
import script from "./add-lead.vue?vue&type=script&lang=js"
export * from "./add-lead.vue?vue&type=script&lang=js"
import style0 from "./add-lead.vue?vue&type=style&index=0&id=36f9c9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f9c9a0",
  null
  
)

export default component.exports